module.exports = __webpack_public_path__ + "static/media/location.862f7ec8.png";